import axios from "axios";

import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {generatePath} from "../../../../utils/getLanguage";

import {
    StyledRelatedAccountsTable, StyledRelatedAccountsTableBody,
    StyledRelatedAccountsTableHead,
    StyledRelatedAccountsTableItem,
    StyledRelatedAccountsTableRow, StyledWrapperTable, EmptyTable
} from "./styledRelatedAccountsListModal";
import {StyledModalLoader} from "../../../elements/payment/styledPaymentInvoice";
import {closableNotification} from "../../../elements/notification/ClosableNotification";

import Dialog from "rc-dialog";
import {NavLink} from "react-router-dom";

import {AppContext} from "../../../../App";

import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import {responseStatus} from "../../../../utils/consts";

import loadingGif from "../../../../assets/images/loading.gif";
import userIcon from "../../../../assets/images/user_icon_dark.svg";

function RelatedAccountsListModal({visible, closeModal, activeNickname}) {
    const {t} = useTranslation("siteOptions");

    const [accountsData, setAccountsData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const {authenticated} = useContext(AppContext);

    const getRelatedAccountsListData = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_MODERATOR_LINK}/users/get-related-${visible === "login" ? "login" : "reg"}-accounts/${activeNickname}`, userAuthenticationConfig()).then(response => {
            if (response.status === responseStatus.HTTP_OK) {
                setAccountsData(response.data);
                setIsLoading(false);
            }
        }).catch(error => {
            closableNotification(error.response.data.message, "error");
            closeModal();
        });
    };

    useEffect(() => {
        if (!visible || !authenticated) return;
        getRelatedAccountsListData();
    }, [visible])

    const formatOnlineDate = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp * 1000);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    function formatRegDate(isoString) {
        const date = new Date(isoString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    return (
        <Dialog
            visible={authenticated && visible}
            wrapClassName="default-modal-wrapper"
            onClose={() => closeModal()}
            animation="zoom"
            maskAnimation="fade"
            title={t("relatedAccountsTitleModal", {nickname: activeNickname})}
            forceRender={false}
            className="default-modal related-user-list-modal"
            style={{margin: "auto"}}
        >
            {isLoading || !accountsData ?
                <StyledModalLoader style={{height: "200px", minHeight: "auto", margin: "auto"}}><img
                    src={loadingGif} alt={"loading..."}/></StyledModalLoader> :
                accountsData?.length === 0 ? <EmptyTable>{t("empty")}</EmptyTable> :
                    <StyledWrapperTable>
                        <StyledRelatedAccountsTable>
                            <StyledRelatedAccountsTableHead>
                                <StyledRelatedAccountsTableRow>
                                    <StyledRelatedAccountsTableItem
                                        style={{minWidth: "140px"}}>{t("user")}</StyledRelatedAccountsTableItem>
                                    <StyledRelatedAccountsTableItem>{t("regUserIpTitle")}</StyledRelatedAccountsTableItem>
                                    <StyledRelatedAccountsTableItem>{t("currentUserIpTitle")}</StyledRelatedAccountsTableItem>
                                    <StyledRelatedAccountsTableItem>{t("dateRegAccountTitle")}</StyledRelatedAccountsTableItem>
                                    <StyledRelatedAccountsTableItem>{t("dateOnlineTittleColumnTable")}</StyledRelatedAccountsTableItem>
                                </StyledRelatedAccountsTableRow>
                            </StyledRelatedAccountsTableHead>
                            <StyledRelatedAccountsTableBody>
                                {accountsData?.map((accountData, key) => (
                                    <StyledRelatedAccountsTableRow key={key}>
                                        <StyledRelatedAccountsTableItem style={{minWidth: "140px"}}>
                                            <NavLink
                                                to={generatePath(`/account/${accountData?.nickname}`)}
                                                onClick={() => closeModal(true)}
                                                className="wrapper-link"
                                            >
                                                <img
                                                    src={userIcon}
                                                    alt="user"
                                                />
                                                {accountData?.nickname}
                                            </NavLink>
                                        </StyledRelatedAccountsTableItem>
                                        <StyledRelatedAccountsTableItem>{accountData?.registerIp}</StyledRelatedAccountsTableItem>
                                        <StyledRelatedAccountsTableItem>{accountData?.currentIp}</StyledRelatedAccountsTableItem>
                                        <StyledRelatedAccountsTableItem>{formatRegDate(accountData?.dateOfRegistration)}</StyledRelatedAccountsTableItem>
                                        <StyledRelatedAccountsTableItem>{formatOnlineDate(accountData?.lastOnlineTime)}</StyledRelatedAccountsTableItem>
                                    </StyledRelatedAccountsTableRow>
                                ))}
                            </StyledRelatedAccountsTableBody>
                        </StyledRelatedAccountsTable>
                    </StyledWrapperTable>
            }
        </Dialog>
    )
}

export default RelatedAccountsListModal;